import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ServiceAreaOneMultiImg = ({ categoryService, services }) => {
  return (
    <div className="service-area-1 space overflow-hidden">
      <Helmet>
        {/* <!-- Basic SEO tags --> */}
        <title>{categoryService} • Leal | Chapa y Pintura - Mecánica</title>
        <meta name="language" content="Spanish" />
        <meta name="author" content="www.lealchapaypintura.com" />
        <meta
          name="description"
          content="Con más de 15 años de trayectoria, en Leal Chapa y Pintura
          combinamos dedicación, técnica y un profundo compromiso con la
          calidad."
        />
        <meta
          name="keywords"
          content="Reparación, Pintura, ITV, chapa y pintura, Automoviles, Motos, Mecánica, Rápida, Chapa, Pintura, Mairena Del Aljarafe, pisa, Sevilla"
        />
        <meta name="robots" content="index, follow" />
        <meta charset="UTF-8" />

        {/* <!-- Open Graph tags for better social media sharing --> */}
        <meta
          property="og:title"
          content="Conócenos • Leal | Chapa y Pintura - Mecánica"
        />
        <meta
          property="og:description"
          content="Con más de 15 años de trayectoria, en Leal Chapa y Pintura
          combinamos dedicación, técnica y un profundo compromiso con la
          calidad."
        />
        <meta property="og:image" content="%PUBLIC_URL%/favicon.ico" />
        <meta property="og:url" content="%PUBLIC_URL%" />
        <meta property="og:type" content="website" />

        {/* <!-- Twitter Card tags for better social media sharing --> */}
        <meta
          name="twitter:title"
          content="Conócenos • Leal | Chapa y Pintura - Mecánica"
        />
        <meta
          name="twitter:description"
          content="Con más de 15 años de trayectoria, en Leal Chapa y Pintura
          combinamos dedicación, técnica y un profundo compromiso con la
          calidad..."
        />

      </Helmet>
      <div className="container">
        <div className="row gy-4 justify-content-center">
          {services.map((service, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="service-card style-shadow compact-card">
                {/* Card Content */}
                <div className="service-card_content">
                  {service.icon && (
                    <div className="service-card_icon">
                      <img
                        src={service.icon}
                        alt={service.altIcon || service.title}
                      />
                    </div>
                  )}
                  <h4 className="service-card_title h5">
                    {service.isExternal ? (
                      <a href={service.link} target="_blank" rel="noopener noreferrer">
                        {service.title}
                      </a>
                    ) : (
                      <Link to={service.link}>{service.title}</Link>
                    )}
                  </h4>
                  <p className="service-card_text">{service.text}</p>
                  {service.badge && (
                    <span className="badge bg-primary mb-2">{service.badge}</span>
                  )}
                  {service.isExternal ? (
                    <a href={service.link} target="_blank" rel="noopener noreferrer" className="link-btn">
                      Reservar en Amovens <i className="fas fa-external-link-alt" />
                    </a>
                  ) : (
                    <Link to={service.link} className="link-btn">
                      Ver más <i className="fas fa-arrow-right" />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceAreaOneMultiImg;
